import { Component } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';

import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { InputControlComponent } from '../../../controls/standard/input-control/input-control.component';

@Component({
	selector: 'app-name-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, InputControlComponent],
	templateUrl: './name-field.component.html',
	styleUrls: ['./name-field.component.scss'],
})
export class NameFieldComponent extends BaseFieldComponent {
	/**
	 * All validators required for this field.
	 * @date 7/15/2022 - 12:02:22 PM
	 *
	 * @public
	 * @static
	 * @override
	 * @type {ValidatorFn[]}
	 */
	public static override validators: ValidatorFn[] = [Validators.required];
}
